import { colors, spacing } from '../../../../../../App/ChakraTheme';
import { VStack } from '@chakra-ui/react';
import styled from '../../../../../../consts/styled';

export const Module = styled(VStack)`
  width: 100%;
  .module {
    width: 100%;
    flex-shrink: 0;
    flex-grow: 1;
    flex-basis: auto;
    padding-right: 15px;
    padding-bottom: ${spacing.BASE}
    position: relative;

    &:not(:last-of-type) .module-title:after,
    .module-title.active-module:after {
      content: '';
      height: calc(100% - 44px);
      width: 1px;
      position: absolute;
      background-color: rgba(213, 214, 222, 0.2);
      left: 21px;
      top: 43px;
      z-index: 0;
    }
  }

  .module-title:hover {
    cursor: pointer;
  }

  .module-title {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: ${spacing.SMALL};
    position: relative;
    transition: padding-bottom 400ms;
    align-items: center;

    &:before {
      background-color: #fff;
      margin-right: 16px;
      content: attr(data-number);
      width: 42px;
      height: 42px;
      border: 1px solid rgba(213, 214, 222, 0.8);
      border-radius: 50%;
      text-align: center;
      font-weight: 300;
      font-size: 24px;
      color: rgb(213, 214, 222);
      transition: all 400ms;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      z-index: 0;
    }

    .icon {
      transition: transform 400ms;
      margin-left: ${spacing.TINY};
      flex-shrink: 0;
      transform: rotate(90deg);

      path[fill] {
        fill: ${colors.darkblue};
      }
    }

    &.disabled-module {
      padding-bottom: ${spacing.TINY};
      h5 {
        color: #ababcb;
      }
      .icon {
        path[fill] {
          fill: #ababcb;
        }
      }
    }

    &.active-module {
      padding-bottom: ${spacing.TINY};

      .icon {
        transform: rotate(90deg) scaleX(-1);
      }

      &:before {
        border-color: rgb(18, 18, 59);
        color: rgb(18, 18, 59);
      }
    }

    &.done {
      &:before {
        color: #fff;
        background: ${colors.limegreen};
        border-color: ${colors.limegreen};
      }
    }

    &.active-module {
      &:before {
        border-color: rgb(18, 18, 59);
      }
    }
  }
`;
